module.exports = __webpack_public_path__ + "static/media/sf-test-14.2ca2e9b3.mp3";